import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import openModal from 'app/modal/actions/open';
import EditCard from 'app/admin/whoisit/cards/modal/edit';
import { ReactComponent as IconPencil } from 'assets/icon/pencil.svg';
import 'app/admin/whoisit/cards/table/editButton.css';
import {useTranslation} from "react-i18next";

const EditButton = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleOpenModal = useCallback(id => dispatch(openModal(EditCard, { id })), [dispatch]);

  return (
    <button
      className="AdminWhoisitCardsEditButton button secondary small"
      title={t('admin.whoisit.cards.editCard')}
      onClick={() => handleOpenModal(id)}
    >
      <IconPencil className="AdminWhoisitCardsEditButtonIcon" />
    </button>
  );
};

export default EditButton;
